import { useVideoBaseData } from './useVideoBaseData';
import { getVideoTableList } from '@opm/services';

/**
 * 通用视频数据 Hook — 支持关键词搜索、排序、下载、卡片/表格切换
 */
export function useVideoTableData({
  filter,
  defaultPageInfo = { page: 1, page_size: 40 },
  translateCategory,
  channel,
}: {
  filter: any;
  defaultPageInfo?: { page: number; page_size: number };
  translateCategory: (value: string, isEn: boolean) => string;
  channel: 'tiktok' | 'youtube';
}) {
  return useVideoBaseData({
    filter,
    apiFunction: getVideoTableList,
    defaultPageInfo,
    translateCategory,
    useFieldMapping: true,
    channel
  });
}
